define('global/Extensions',[
    'jquery',
    'lodash',
    './Logger'
], function ($, _, Logger) {
    'use strict';
    function b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    function downloadFile(file, filename) {
        var uncoded = b64DecodeUnicode(file);
        var blob = new Blob([uncoded], { type: 'text/plain' });

        if (navigator.msSaveOrOpenBlob) {
            // Works for Internet Explorer and Microsoft Edge
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {

            var a = document.createElement('a');
            a.download = filename;
            a.href = window.URL.createObjectURL(blob);
            a.textContent = 'Download ready';

            a.draggable = true;
            a.classList.add('dragout');

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

    function initMoreLinks() {
        var maxWidth = $(window).width() < 1280 ? 185 : 240;
        var elements = $('.listing-desc-all');
        $.each(elements, function (index, element) {
            var link = $(element).find('.listing-desc-more');
            var text = $(element).find('.listing-desc');
            if ($(text).width() >= maxWidth) {
                link.html("More");
                link.css('display', 'inline-block');
            } else {
                link.html("");
                link.css('display', 'none');
            }
        });
    }

    function getAttributeValue(product, key) {
        var customFields = product.customFields;
        if (!customFields || customFields[key] === null || customFields[key] === undefined ||
            ($.isArray(customFields[key]) && customFields[key].length === 0)) {
            return null;
        }

        return $.isArray(customFields[key])
            ? customFields[key][0].value
            : customFields[key];
    }

    function toCamelCase(obj) {
        if (!obj || typeof obj !== "object") {
            return null;
        }

        if (obj instanceof Array) {
            return $.map(obj, function (value) {
                return toCamelCase(value);
            });
        }

        var newObj = {};
        $.each(obj, function (key, value) {
            key = key.charAt(0).toLowerCase() + key.slice(1);
            if (typeof value == "object" && !(value instanceof Array)) {
                value = toCamelCase(value);
            }
            if (Array.isArray(value)) {
                $.each(value, function (key, item) {
                    value[key] = toCamelCase(item);
                    var test = 'test';
                })
            }
            newObj[key] = value;
        });
        return newObj;
    }

    var Extensions = {
        getAttributeValue: getAttributeValue,
        downloadFile: downloadFile,
        initMoreLinks: initMoreLinks,
        toCamelCase: toCamelCase
    }

    Logger.debug('Extensions.js Loaded:', Extensions);

    return Extensions;


});
